import React, { useState } from "react";
import { Typography, Button, Box } from "@mui/material";
import { withStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import Grid from "@mui/material/Grid2";
import AppAnimate from "../../components/AppAnimate";
import { connect, getStore } from "trim-redux";
import AppCard from "../../components/layout/components/AppCard";
import { Styles } from "../../../config/design/styles";
import { useTranslation } from "react-i18next";
import Logo from "../../components/elements/Logo";
import Title from "../../components/elements/Title";
import clsx from 'clsx';
import RayaField from "../../components/elements/fields/RayaField";
import axios from "axios";
import {defaultVariables} from "../../../config";
import LoadingButton from "../../components/elements/LoadingButton";
import {showSimpleDate} from "../../../config/values";
import {theme} from "../../../config/design/theme";
import BgStock from "../../../files/img/bg/bgbanner.png";
import LanguageSwitcher from "../../components/layout/components/LanguageSwitcher"; // Assuming this is your custom submit button component

const CheckStock = ({ classes }) => {
    const [number, setNumber] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const isAuth = getStore('isAuth');

    const handleChange = (e) => {
        setNumber(e.target.value);
        if (error) setError("");
    };

    const handleSubmit = async () => {
        if (!number.trim()) {
            setError(t("requiredField"));
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${defaultVariables.url}/check-stock`, { number });
            setResult(response.data);
        } catch (err) {
            enqueueSnackbar(t("somethingWentWrong"), { variant: "warning" });
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        setNumber("");
        setResult(null);
        setError("");
    };

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('checkStock')}>
            <div className={clsx(classes.checkContentInner)} >
                    <Grid container spacing={2} justifyContent={"center"} className='bg-stock-check' style={{backgroundImage:`url(${BgStock})`}}>
                        <Grid item size={{xs:12,sm:10,md:8,lg:6,xl:5 }} style={{ marginTop: 20, marginBottom: 30 }}>
                            <div style={{position:'absolute',top:5,left:5,zIndex:10}}>
                                <LanguageSwitcher/>
                            </div>
                            <Box className="top-sec-check text-center">
                                <Logo old_logo parentStyle={{ textAlign: "center", width: '100%' }} style={{ width: 150 }} />


                            </Box>
                           <Box className="box-center">

                               {!result ? (
                                   <>
                                      <div>
                                          <Title color="field" align="left">{t("checkStock")}</Title>
                                          <Typography>{t("checkStockDesc")}</Typography>
                                      </div>

                                       <div>
                                           <RayaField
                                               fullWidth
                                               label={t("stockNumber")}
                                               name="number"
                                               variant="outlined"
                                               dir="ltr"
                                               onChange={handleChange}
                                               value={number}
                                               placehodler={"KD..."}
                                               margin="normal"
                                               error={!!error}
                                               helperText={error}
                                               style={{marginBottom:20}}
                                           />
                                           <LoadingButton
                                               onClick={handleSubmit}
                                               loading={loading}
                                               type="submit"
                                               variant="contained"
                                               color="primary"
                                               size="large"
                                               fullWidth
                                               style={{width:"100%"}}
                                               styleForParent={{margin:"10px 0"}}
                                           >
                                               {t("check")}
                                           </LoadingButton>
                                       </div>
                                   </>
                               ) : (
                                   <>
                                       <div style={{ marginTop: 20 }}>
                                           <Title color="field" align="left">{t("checkStock")}</Title>
                                           <Typography variant="h6">{t("stockDetails")}</Typography>
                                       </div>
                                       <Box style={{backgroundColor:theme.palette.lightSecondary.main}} className='bg-default'>
                                           <Typography>{t("stockNumber")}: {result.stock.number}</Typography>
                                           <Typography>{t("ownerName")}: {result.user.first_name}  {result.user.last_name}</Typography>
                                           <Typography>{t("purchaseDate")}: {showSimpleDate(result.created_at)}</Typography>
                                       </Box>
                                       <Button
                                           variant="contained"
                                           color="primary"
                                           onClick={handleBack}
                                           style={{ marginTop: 20, width:"100%" }}
                                           fullWidth
                                       >
                                           {t("back")}
                                       </Button>
                                   </>
                               )}
                           </Box>
                        </Grid>
                    </Grid>
            </div>
        </AppAnimate>
    );
};

const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(CheckStock));